import { useState } from "react";

function TechnicalDeadlinesPanel({
  cardStyle,
  emptyBoxStyle,
  inputStyle,
  sectionTitleStyle,
  primaryButtonStyle,
  scadenzeTecniche,
  mostraNuovaScadenza,
  nuovaScadenza,
  setMostraNuovaScadenza,
  setNuovaScadenza,
  salvaNuovaScadenza,
  completaScadenzaTecnica,
  eliminaScadenzaTecnica,
  modificaScadenzaTecnica,
  formatDate,
  getStatusBadge,
  renderActions,
}) {

const utenteCorrente = JSON.parse(
  localStorage.getItem("utenteCorrente")
);

  const labelStyle = {
    fontSize: "13px",
    fontWeight: 700,
    marginBottom: "6px",
    color: "#475569",
  };

  const helpTextStyle = {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "5px",
    lineHeight: "1.4",
  };

  const fieldWrapperStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const [scadenzaInModificaId, setScadenzaInModificaId] = useState(null);

const [scadenzaModificata, setScadenzaModificata] = useState({
  title: "",
  due_date: "",
  frequency_months: "",
  status: "Programmato",
  notes: "",
});

  const getDeadlinePriority = (dueDate, status) => {
  if (status === "Completata") return "done";
  if (!dueDate) return "normal";

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const deadlineDate = new Date(dueDate);
  deadlineDate.setHours(0, 0, 0, 0);

  const diffDays = Math.ceil(
    (deadlineDate - today) / (1000 * 60 * 60 * 24)
  );

  if (diffDays < 0) return "critical";
  if (diffDays <= 30) return "warning";

  return "normal";
};

const getDeadlineCardStyle = (item) => {
  const priority = getDeadlinePriority(item.due_date, item.status);

  const styles = {
    critical: {
      border: "1px solid #fecaca",
      background: "#fff1f2",
    },
    warning: {
      border: "1px solid #fed7aa",
      background: "#fff7ed",
    },
    done: {
      border: "1px solid #bbf7d0",
      background: "#f0fdf4",
    },
    normal: {
      border: "1px solid #dbe4f0",
      background: "#f8fbff",
    },
  };

  return styles[priority];
};

const getDeadlineLabel = (item) => {
  const priority = getDeadlinePriority(item.due_date, item.status);

  if (priority === "critical") return "Scaduta";
  if (priority === "warning") return "In scadenza";
  if (priority === "done") return "Completata";

  return "Programmato";
};

const getDeadlineLabelStyle = (item) => {
  const priority = getDeadlinePriority(item.due_date, item.status);

  const styles = {
    critical: {
      background: "#fee2e2",
      color: "#991b1b",
    },
    warning: {
      background: "#fef3c7",
      color: "#92400e",
    },
    done: {
      background: "#dcfce7",
      color: "#166534",
    },
    normal: {
      background: "#e2e8f0",
      color: "#334155",
    },
  };

  return {
    ...styles[priority],
    display: "inline-flex",
    alignItems: "center",
    padding: "5px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 800,
  };
};

  const handleCompletaScadenza = (id) => {
    if (typeof completaScadenzaTecnica !== "function") {
      alert("Funzione completamento verifica tecnica non ancora collegata.");
      return;
    }

    completaScadenzaTecnica(id);
  };

const handleEliminaScadenza = (id) => {
  if (typeof eliminaScadenzaTecnica !== "function") {
    alert("Funzione eliminazione non disponibile.");
    return;
  }

  eliminaScadenzaTecnica(id);
};

  return (
    <div style={cardStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "14px",
        }}
      >
        <h2 style={sectionTitleStyle}>
  Scadenze tecniche ({scadenzeTecniche.length})
</h2>

        {utenteCorrente?.role !== "viewer" && (
  <button
    className="btn btn-primary"
    onClick={() => setMostraNuovaScadenza(true)}
    style={primaryButtonStyle}
  >
    + Scadenza
  </button>
)}
      </div>

      {mostraNuovaScadenza && (
        <div
          style={{
            ...emptyBoxStyle,
            marginBottom: "18px",
            display: "flex",
            flexDirection: "column",
            gap: "14px",
          }}
        >
          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Nome verifica o scadenza</div>
            <input
              placeholder="Esempio: Controllo fumi, verifica periodica, rinnovo certificazione"
              value={nuovaScadenza.title}
              onChange={(e) =>
                setNuovaScadenza({
                  ...nuovaScadenza,
                  title: e.target.value,
                })
              }
              style={inputStyle}
            />
            <div style={helpTextStyle}>
              Inserisci il nome dell’adempimento tecnico da controllare o rinnovare.
            </div>
          </div>

          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Data scadenza</div>
            <input
              type="date"
              value={nuovaScadenza.due_date}
              onChange={(e) =>
                setNuovaScadenza({
                  ...nuovaScadenza,
                  due_date: e.target.value,
                })
              }
              style={inputStyle}
            />
            <div style={helpTextStyle}>
              È la data entro cui la verifica o l’adempimento deve essere completato.
            </div>
          </div>

          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Periodicità della verifica</div>
            <input
              type="number"
              min="1"
              placeholder="Esempio: 12 per annuale, 24 per biennale"
              value={nuovaScadenza.frequency_months || ""}
              onChange={(e) =>
                setNuovaScadenza({
                  ...nuovaScadenza,
                  frequency_months: e.target.value,
                })
              }
              style={inputStyle}
            />
            <div style={helpTextStyle}>
              Campo facoltativo. Se compilato, quando completi la verifica il sistema calcola automaticamente la prossima scadenza.
            </div>
          </div>

          <div style={fieldWrapperStyle}>
            <div style={labelStyle}>Note operative</div>
            <textarea
              placeholder="Esempio: Verificare documentazione, prenotare tecnico, controllare esito precedente."
              value={nuovaScadenza.notes}
              onChange={(e) =>
                setNuovaScadenza({
                  ...nuovaScadenza,
                  notes: e.target.value,
                })
              }
              rows={3}
              style={{ ...inputStyle, resize: "vertical" }}
            />
            <div style={helpTextStyle}>
              Aggiungi dettagli utili per gestire correttamente la scadenza.
            </div>
          </div>

          {renderActions(
            salvaNuovaScadenza,
            () => setMostraNuovaScadenza(false),
            "Salva scadenza"
          )}
        </div>
      )}

      {scadenzeTecniche.length === 0 ? (
        <div style={emptyBoxStyle}>Nessuna scadenza tecnica registrata.</div>
      ) : (
  <div
    style={{
      maxHeight: scadenzeTecniche.length > 2 ? "650px" : "none",
      overflowY: scadenzeTecniche.length > 2 ? "auto" : "visible",
      paddingRight: scadenzeTecniche.length > 2 ? "6px" : 0,
    }}
  >
    {scadenzeTecniche.map((item) => (
          <div
            key={item.id}
            style={{
  ...emptyBoxStyle,
  ...getDeadlineCardStyle(item),
  marginBottom: "12px",
}}
          >
           <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "6px",
  }}
>
  <strong>{item.title || "Scadenza tecnica"}</strong>

  {item.notes?.includes("Generata automaticamente dal documento") && (
    <span
      style={{
        background: "#dbeafe",
        color: "#1d4ed8",
        padding: "4px 10px",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
      }}
    >
      📄 Documento
    </span>
  )}
</div> 

<div
  style={{
    marginTop: "8px",
    marginBottom: "8px",
  }}
>
  <span style={getDeadlineLabelStyle(item)}>
    {getDeadlineLabel(item)}
  </span>
</div>

<div>
  <strong>Data scadenza:</strong> {formatDate(item.due_date)}
</div>

            <div>
              <strong>Periodicità:</strong>{" "}
              {item.frequency_months
                ? `ogni ${item.frequency_months} mesi`
                : "Non ricorrente"}
            </div>

            {item.notes &&
 !item.notes.includes("Generata automaticamente dal documento") && (
  <div>
    <strong>Note operative:</strong> {item.notes}
  </div>
)}

            {item.status !== "Completata" ? (
  utenteCorrente?.role !== "viewer" && (
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginTop: "12px",
        flexWrap: "wrap",
      }}
    >
      <button
        onClick={() => {
          setScadenzaInModificaId(item.id);
          setScadenzaModificata({
            title: item.title || "",
            due_date: item.due_date || "",
            frequency_months: item.frequency_months || "",
            status: item.status || "Programmato",
            notes: item.notes || "",
          });
        }}
        style={{
          background: "#e0f2fe",
          color: "#075985",
          border: "none",
          borderRadius: "10px",
          padding: "10px 16px",
          cursor: "pointer",
          fontWeight: 700,
          fontSize: "14px",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#bae6fd";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#e0f2fe";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        ✏️ Modifica
      </button>

      <button
        onClick={() => handleCompletaScadenza(item.id)}
        style={{
          background: "#dbeafe",
          color: "#1e40af",
          border: "none",
          borderRadius: "10px",
          padding: "10px 16px",
          cursor: "pointer",
          fontWeight: 700,
          fontSize: "14px",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#bfdbfe";
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow =
            "0 4px 10px rgba(30,64,175,0.18)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#dbeafe";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        ✓ Completa verifica
      </button>

      <button
        onClick={() => handleEliminaScadenza(item.id)}
        style={{
          background: "#dc2626",
          color: "#fff",
          border: "none",
          borderRadius: "10px",
          padding: "10px 16px",
          cursor: "pointer",
          fontWeight: 700,
          fontSize: "14px",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#b91c1c";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#dc2626";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        🗑 Elimina
      </button>
    </div>
  )
) : (
  <div
    style={{
      marginTop: "12px",
      background: "#ecfeff",
      color: "#0f766e",
      borderRadius: "8px",
      padding: "8px 12px",
      fontWeight: 700,
      display: "inline-block",
    }}
  >
    ✓ Verifica completata
  </div>
)}

{scadenzaInModificaId === item.id && (
  <div
    style={{
      marginTop: "16px",
      padding: "16px",
      borderRadius: "12px",
      background: "#f8fafc",
      border: "1px solid #dbeafe",
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    }}
  >
    <input
      value={scadenzaModificata.title}
      onChange={(e) =>
        setScadenzaModificata({
          ...scadenzaModificata,
          title: e.target.value,
        })
      }
      placeholder="Titolo scadenza"
      style={inputStyle}
    />

    <input
      type="date"
      value={scadenzaModificata.due_date}
      onChange={(e) =>
        setScadenzaModificata({
          ...scadenzaModificata,
          due_date: e.target.value,
        })
      }
      style={inputStyle}
    />

    <input
      type="number"
      min="1"
      value={scadenzaModificata.frequency_months || ""}
      onChange={(e) =>
        setScadenzaModificata({
          ...scadenzaModificata,
          frequency_months: e.target.value,
        })
      }
      placeholder="Periodicità in mesi"
      style={inputStyle}
    />

    <select
  value={scadenzaModificata.status}
  onChange={(e) =>
    setScadenzaModificata({
      ...scadenzaModificata,
      status: e.target.value,
    })
  }
  style={inputStyle}
>
  <option value="Programmato">Programmato</option>
  <option value="Completata">Completata</option>
  <option value="Annullata">Annullata</option>
</select>

    <textarea
      value={scadenzaModificata.notes}
      onChange={(e) =>
        setScadenzaModificata({
          ...scadenzaModificata,
          notes: e.target.value,
        })
      }
      rows={3}
      placeholder="Note operative"
      style={{
        ...inputStyle,
        resize: "vertical",
      }}
    />

    <div
      style={{
        display: "flex",
        gap: "10px",
      }}
    >
      <button
        onClick={() => {
          if (typeof modificaScadenzaTecnica !== "function") {
            alert("Funzione modifica scadenza tecnica non disponibile.");
            return;
          }

          modificaScadenzaTecnica(item.id, scadenzaModificata);
          setScadenzaInModificaId(null);
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow =
            "0 4px 12px rgba(23,58,99,0.25)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
        style={{
          ...primaryButtonStyle,
          transition: "all 0.2s ease",
        }}
      >
        Salva modifiche
      </button>

      <button
        onClick={() => setScadenzaInModificaId(null)}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#cbd5e1";
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow =
            "0 4px 10px rgba(71,85,105,0.18)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#e2e8f0";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
        style={{
          background: "#e2e8f0",
          border: "none",
          borderRadius: "8px",
          padding: "10px 14px",
          cursor: "pointer",
          fontWeight: 600,
          transition: "all 0.2s ease",
        }}
      >
        Annulla
      </button>
    </div>
  </div>
)}
                    </div>
        ))}
  </div>
)}
    </div>
  );
}

export default TechnicalDeadlinesPanel;